import Api from './Api';

export default class NoticiasApi {

    mesAno = async (_mes_id, _ano) => {
        return await Api.get(`noticias/mes/${_mes_id}/ano/${_ano}`).then(response => {
            return response.data;
        }).catch((error) => console.log('[NoticiasApi.MESANO]: Error\n', error));
    }

    ultimas = async (_numeroPublicacoes) => {
        return await Api.get(`noticias/ultimas/${_numeroPublicacoes}`).then(response => {
            return response.data;
        }).catch((error) => console.log('[NoticiasApi.ULTIMAS]: Error\n', error));
    }

    destacadas = async () => {
        return await Api.get(`noticias/destacadas`).then(response => {
            return response.data;
        }).catch((error) => console.log('[NoticiasApi.destacadas]: Error\n', error));
    }

    anos = async () => {
        return await Api.get(`noticias/anos`).then(response => {
            return response.data;
        }).catch((error) => console.log('[NoticiasApi.ANOS]: Error\n', error));
    }

    pesquisar = async (_pesquisa) => {
        return await Api.get(`noticias/pesquisar/${_pesquisa}`).then(response => {
            return response.data;
        }).catch((error) => console.log('[NoticiasApi.PESQUISAR]: Error\n', error));
    }

}